import { connect } from 'react-redux';
import fetchCSVReport from '../store/report';
import Header from './Header';

const mapDispatch = {
  fetchCSVReport,
};

export default connect(null, mapDispatch)(Header);
